var map = {
	"account/account.module.ngfactory": [
		"./src/account/account.module.ngfactory.js",
		"account.module"
	],
	"app/admin/admin.module.ngfactory": [
		"./src/app/admin/admin.module.ngfactory.js",
		"admin.module",
		"common"
	],
	"app/booking-lists/booking-lists.module.ngfactory": [
		"./src/app/booking-lists/booking-lists.module.ngfactory.js",
		"common",
		"booking-lists.module"
	],
	"app/magic-numbers/magic-numbers.module.ngfactory": [
		"./src/app/magic-numbers/magic-numbers.module.ngfactory.js",
		"magic-numbers.module",
		"common"
	],
	"app/main/main.module.ngfactory": [
		"./src/app/main/main.module.ngfactory.js",
		"main.module",
		"common"
	],
	"app/patient-tracking-list/patient-tracking-list.module.ngfactory": [
		"./src/app/patient-tracking-list/patient-tracking-list.module.ngfactory.js",
		"common",
		"patient-tracking-list.module"
	],
	"app/smart-scheduling/smart-scheduling.module.ngfactory": [
		"./src/app/smart-scheduling/smart-scheduling.module.ngfactory.js",
		"common",
		"smart-scheduling.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main